import React, { useState, useEffect } from 'react';

// Costante per il colore dell'ombra
const SHADOW_COLOR = 'rgba(0,0,0,0.05)';

const SummaryGrid = ({ children }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Controlla se ci sono pochi figli (meno di 3-4)
    const childrenCount = React.Children.count(children);
    const useFlex = childrenCount <= 4;

    return (
        <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            flexWrap: !isMobile && !useFlex ? 'wrap' : 'nowrap',
            gap: isMobile ? 'clamp(0.5rem, 2vw, 0.75rem)' : '0',
            marginBottom: 'clamp(0.625rem, 3vw, 1.25rem)',
            width: '100%',
            height: isMobile ? 'auto' : 'clamp(6rem, 14vh, 8rem)' // Altezza fissa per desktop
        }}>
            {React.Children.map(children, (child, index) => {
                if (!child) return null;

                const isFirst = index === 0;
                const isLast = index === childrenCount - 1;

                // Se è mobile, tutte le card hanno bordi arrotondati
                // Se non è mobile, solo la prima e l'ultima hanno bordi arrotondati
                const cardStyle = {
                    flex: isMobile ? '1 0 auto' : (useFlex ? '1' : 'unset'),
                    width: isMobile ? '100%' : (useFlex ? 'auto' : childrenCount === 5 ? '20%' : childrenCount === 6 ? '16.66%' : '25%'),
                    marginBottom: isMobile ? 'clamp(0.5rem, 2vw, 0.75rem)' : '0',
                    overflow: 'hidden',
                    boxShadow: `clamp(0rem, 0.1vw, 0rem) clamp(0.0625rem, 0.5vw, 0.125rem) clamp(0.3125rem, 2.5vw, 0.625rem) ${SHADOW_COLOR}`,
                    borderRadius: '0',
                    height: isMobile ? 'clamp(6rem, 14vh, 8rem)' : '100%' // Altezza fissa per le singole card
                };

                if (isMobile) {
                    // In mobile, ogni card ha i bordi arrotondati
                    cardStyle.borderRadius = 'clamp(0.25rem, 2vw, 0.5rem)';
                } else {
                    // In desktop, solo la prima e l'ultima hanno i bordi arrotondati nei lati esterni
                    if (isFirst) {
                        cardStyle.borderTopLeftRadius = 'clamp(0.25rem, 2vw, 0.5rem)';
                        cardStyle.borderBottomLeftRadius = 'clamp(0.25rem, 2vw, 0.5rem)';
                    }
                    if (isLast) {
                        cardStyle.borderTopRightRadius = 'clamp(0.25rem, 2vw, 0.5rem)';
                        cardStyle.borderBottomRightRadius = 'clamp(0.25rem, 2vw, 0.5rem)';
                    }
                }

                return (
                    <div
                        key={index}
                        style={cardStyle}
                    >
                        {React.cloneElement(child, {
                            index: index,
                            totalitems: isMobile ? 1 : childrenCount
                        })}
                    </div>
                );
            })}
        </div>
    );
};

export default SummaryGrid;